<template>
  <Lock
    v-if="item.data.lock"
    :size="size"
    :stroke-width="strokeWidth"
    class="cursor-pointer text-gray-400 hover:text-gray-300" />
  <LockOpen v-else :size="size" :stroke-width="strokeWidth" class="cursor-pointer text-gray-500 hover:text-gray-400" />
</template>
<script setup>
import { Lock, LockOpen } from 'lucide-vue-next';

defineProps({
  item: {
    type: Object,
    required: true,
  },
  size: {
    type: Number,
    default: 14,
  },
  strokeWidth: {
    type: [String, Number],
    default: 2,
  },
});
</script>
